import { DataDate } from "../model/data_date";

class TargetDate {
  private element: JQuery;

  constructor(element: JQuery) {
    this.element = element;
  }

  initialize(): void {
    (this.element as any).datepicker({
      minDate: this.minDataDate(),
      maxDate: this.maxDataDate(),
    });
  }

  private minDataDate(): string {
    return this.element.data("min");
  }

  private maxDataDate(): string {
    return this.element.data("max");
  }

  stringValue(): string {
    return this.element.val() as string;
  }

  getDataDate(partition: string): DataDate | null {
    return DataDate.parseYMD(this.element.val() as string, partition);
  }

  onChange(f: () => void): void {
    this.element.change(f);
  }
}

export { TargetDate };
